import { render } from "./ContactPageForm.vue?vue&type=template&id=50c6b730&scoped=true"
import script from "./ContactPageForm.vue?vue&type=script&lang=js"
export * from "./ContactPageForm.vue?vue&type=script&lang=js"

import "./ContactPageForm.vue?vue&type=style&index=0&id=50c6b730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c6b730"]])

export default __exports__